import {
  SET_INVENTORY2_FILTERS,
  SET_INVENTORY2_DATE_RANGE,
  SET_INVENTORY2_DATA,
  CLEAR_INVENTORY2_STATE,
} from '../actions/inventory2Actions';

interface Inventory2State {
  filters: any[];
  dateRange: [string, string] | null;
  data: any;
  lastFetched: number | null;
}

const initialState: Inventory2State = {
  filters: [],
  dateRange: null,
  data: {},
  lastFetched: null,
};

const inventory2Reducer = (state: Inventory2State | undefined, action: any): Inventory2State => {
  if (!state) state = initialState;
  switch (action.type) {
    case SET_INVENTORY2_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case SET_INVENTORY2_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };

    case SET_INVENTORY2_DATA:
      return {
        ...state,
        data: action.payload,
        lastFetched: Date.now(),
      };

    case CLEAR_INVENTORY2_STATE:
      return initialState;

    default:
      return state;
  }
};

export default inventory2Reducer;
